import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);
  const [authTab, setAuthTab] = useState("login");
  const [walletOpen, setWalletOpen] = useState(false);
  const [site, setSite] = useState({ site_name: "XVER" });

  useEffect(() => {
    api.get("/site").then(({ data }) => {
      setSite(data);
      if (data.meta_title) document.title = data.meta_title;
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.name = "description";
        document.head.appendChild(m);
      }
      m.content = data.meta_description || "";
    }).catch(() => {});
  }, []);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(TOKEN_KEY)) {
      setUser(null);
      setReady(true);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setUser(null);
    }
    setReady(true);
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const signIn = (token, u) => {
    localStorage.setItem(TOKEN_KEY, token);
    setUser(u);
  };
  const signOut = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(null);
  };
  const openAuth = (tab = "login") => {
    setAuthTab(tab);
    setAuthOpen(true);
  };
  const setBalance = (b) => setUser((u) => (u ? { ...u, balance: b } : u));

  return (
    <AuthCtx.Provider
      value={{ user, ready, refresh, signIn, signOut, setUser, setBalance, authOpen, setAuthOpen, authTab, setAuthTab, openAuth, walletOpen, setWalletOpen, site }}
    >
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
